// Singleton URLs
export const URL = "centric://REFLECTION/";
export const URL_ROOT = "centric://REFLECTION/_CS_Reflection";
export const URL_BO = "centric://REFLECTION/BusinessObject/";
export const URL_COMPANY = "centric://REFLECTION/INSTANCE/CompanyInfo/Global";
export const URL_DATA_SETUP = "centric://REFLECTION/INSTANCE/_CS_DataSetup/null";
export const URL_ENUM = "centric://REFLECTION/ENUM/";
export const URL_FORM_CONFIG_INSTANCE = "centric://REFLECTION/INSTANCE/FormDefinitionConfig/";
export const URL_INSTANCE = "centric://REFLECTION/INSTANCE/";
export const URL_FILESYSTEM_ROOT = "centric://REFLECTION/INSTANCE/FileSystemFolder/Root";
export const URL_HIGG = "centric://REFLECTION/INSTANCE/HiggGlobal";
export const URL_HOME = "centric://REFLECTION/INSTANCE/_CS_Data/null";
export const URL_SITE = "centric://SITEADMIN/_CS_Site";
export const URL_SITE_PREFERENCES = "centric://REFLECTION/INSTANCE/SitePreferences/null";
export const URL_SUBTYPE_ADOBE_SUBSTANCE = "centric://REFLECTION/INSTANCE/DocumentSubtype/Adobe Substance";
export const URL_SUBTYPE_UNIFIED_3D_MATERIAL = "centric://REFLECTION/INSTANCE/DocumentSubtype/Unified 3D Material";
export const URL_SUBTYPE_CLO = "centric://REFLECTION/INSTANCE/DocumentSubtype/Clo";
export const URL_SUBTYPE_3D_VIEWABLE = "centric://REFLECTION/INSTANCE/DocumentSubtype/3D Viewable";
export const URL_TASKS = "centric://REFLECTION/INSTANCE/_CS_Tasks/null";

// Common Types
export const TYPE_ABSTRACT_REVISABLE = "_CS_AbstractRevisable";
export const TYPE_BUSINESS_OBJECT = "BusinessObject";
export const TYPE_CLASS_CONFIGURATION = "ClassConfiguration";
export const TYPE_CONFIGURABLE_ATTRIBUTE = "ConfigurableAttribute";
export const TYPE_DATA_SETUP = "_CS_DataSetup";
export const TYPE_DOC_AND_COMMENT_OWNER = "DocAndCommentOwner";
export const TYPE_ENUM = "EnumList";
export const TYPE_ENUM_VALUE = "EnumValue";
export const TYPE_HOME = "_CS_Data";
export const TYPE_IMAGE = "Image";
export const TYPE_IMAGE_CONTAINER = "ImageContainer";
export const TYPE_LOOKUP_ITEM = "LookupItem";
export const TYPE_QUEUES_SERVICES = "_CS_QueuesAndServices";
export const TYPE_REVISION = "_CS_Revision";
export const TYPE_TAG = "Tag";
export const TYPE_TAGSPEC = "TagSpec";
export const TYPE_LOCALIZED_ITEM = "LocalizedItem";
export const TYPE_SITE = "_CS_Site";
export const TYPE_SUBTYPE = "Subtype";
export const TYPE_SUBTYPED_CLASS = "SubtypedClass";
export const TYPE_TABLE_REPORT = "TableReport";
export const TYPE_TASKS = "_CS_Tasks";
export const TYPE_UOM_CONVERSION = "UOMConversion";
export const TYPE_USER = "User";
export const TYPE_VIEW = "_CS_PreferenceView";

// Common attributes
export const ATTR_MODIFIED_AT = "ModifiedAt";
export const ATTR_MODIFIED_BY = "ModifiedBy";
export const ATTR_TAGS = "Tags";

// Image attributes
export const ATTR_THUMBNAIL = "Thumbnail";
export const ATTR_VIEWABLE = "Viewable";
export const ATTR_MEDIUM_IMAGE = "SmallImage";
export const ATTR_LARGE_IMAGE = "LargeImage";
export const ATTR_IMAGES = "Images";

// ConfigurableAttribute attributes
export const ATTR_AUTOFILL_DEPENDENT_ENUM = "AutofillDependentEnum";
export const ATTR_COPY_CATEGORIES = "CopyCategories";
export const ATTR_COPY_CATEGORIES_LOCKED = "CopyCategoriesLocked";
export const ATTR_COPY_OPTION_NAME = "CopyOptionName";
export const ATTR_DEPENDS_ON = "DependsOn";
export const ATTR_DEPENDS_ON_PATH = "DependsOnPath";
export const ATTR_ENABLED = "Enabled";
export const ATTR_EXP = "Expression";
export const ATTR_EXPRESSION_STATE = "ExpressionState";
export const ATTR_FLAGS = "Flags";
export const ATTR_FORMAT = "Format";
export const ATTR_COMMENT_RESTRICTED = "CommentRestricted";
export const ATTR_COLUMN_WIDTH = "ColumnWidth";
export const ATTR_OPTIONAL = "Optional";
export const ATTR_ATTRIBUTES = "Attributes";
export const ATTR_VALUE = "Initial Value";
export const ATTR_VALUETYPE = "Value Type";
export const ATTR_SETUP_SETTINGS = "SetupSettings";
export const ATTR_SUBTYPE = "Subtype";
export const ATTR_REFLECTION_ATTR_OWNER = "ReflectionAttributeOwner";
export const ATTR_VIABLE_MATRIX = "ViableMatrix";
export const ATTR_HIDDEN = "Hidden";
export const ATTR_EXP_ONCLIENT_DISABLED = "ExpressionOnClientDisabled";
export const ATTR_RECENT_CHILD_COMMENTS = "RecentChildComments";
export const ATTR_RECENT_COMMENTS = "RecentComments";
export const ATTR_REQUIRED = "Required";
export const ATTR_REST_EXPOSED = "RestApiExposed";
export const ATTR_REST_RESTRICTED = "RestRestricted";
export const ATTR_REST_UPDATE = "RestUpdate";
export const ATTR_TARGET_CLASS_NAME = "TargetClassName";
export const ATTR_TARGET_CLASS_SUBTYPE_ID = "TargetClassSubtypeAttributeId";
export const ATTR_VALIDATION_EXPRESSION = "ValidationExpression";
export const ATTR_NOTES = "Notes";

// Master-Revision relations
export const ATTR_CURRENT_REVISION = "CurrentRevision";
export const ATTR_LATEST_REVISION = "LatestRevision";
export const ATTR_MASTER = "Master";
export const ATTR_PHASE = "Phase";
export const ATTR_PHASE_REVISIONS = "PhaseCurrentRevisions";
export const ATTR_REVISIONS = "Revisions";
export const ATTR_STATE = "State";
export const ATTR_STATE_MACHINE = "StateMachine";
export const DEFAULT_IMAGE_LABEL = "";

// The name of the enumeration with the list of possible image export formats
export const IMAGE_EXPORT_FORMAT = "ImageExportFormat";

// Enumeration values for the image export format
export const IMAGE_EXPORT_FORMAT_DEFAULT = "";
export const IMAGE_EXPORT_FORMAT_IMAGEID_IMAGES_JPG = "ImageExportFormat:Static";
export const IMAGE_EXPORT_FORMAT_IMAGEID_IMAGE_NODENAME_JPG = "ImageExportFormat:Dynamic";

// The name of the enumeration with the list of possible image sizes
export const IMAGE_SIZE_ENUM = "ImageSize";

// Enumeration values for the image size
export const IMAGE_SIZE_SMALLEST = "ImageSize:Smallest";
export const IMAGE_SIZE_SMALL = "ImageSize:Small";
export const IMAGE_SIZE_MEDIUM = "ImageSize:Medium";
export const IMAGE_SIZE_LARGE = "ImageSize:Large";
export const IMAGE_SIZE_LARGEST = "ImageSize:Largest";
export const IMAGE_SIZE_ICON = "ImageSize:Icon";
export const IMAGE_SIZE_ORIGINAL = "ImageSize:Original";
export const IMAGE_SIZE_USE_LARGE_IMAGE = "ImageSize:UseLargeImage";

// Enumeration values for RevisionStateOptions on master config
export const REVISION_ACTIONS_ALL = "RevisionStateOptions:EnableActionsAllRevisions";
export const REVISION_ACTIONS_LATEST = "RevisionStateOptions:EnableActionsLatestRevision";
export const PATH_PARENT = "Child:__Parent__";
export const PATH_CURRENT_REVISION = "Child:CurrentRevision";
export const PATH_LATEST_REVISION = "Child:LatestRevision";
export const REVISION_DRAFT = "Revision.State:DRAFT";
export const REVISION_PENDING = "Revision.State:PENDING";
export const REVISION_PENDING2 = "Revision.State:PENDING2";
export const REVISION_REVIEW = "Revision.State:REVIEW";
export const REVISION_APPROVED = "Revision.State:APPROVED";
export const REVISION_ABANDONED = "Revision.State:ABANDONED";
export const REVISION_CLOSED = "Revision.State:CLOSED";
export const REVISION_SUPERSEDED = "Revision.State:SUPERSEDED";
export const REVISION_STATE_ENUM = "Revision.State";
export const COPY_CATEGORY_ENUM = "CopyCategory";
export const COPY_CATEGORY_NO_COPY = "NoCopy";
export const COPY_CATEGORY_OPTIONAL = "Optional";
export const COPY_CATEGORY_OPTIONAL_PASSIVE = "Optional-Passive";
export const COPY_CATEGORY_NO_CONTRIBUTE = "NoContribute";
